// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./TagTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tag-module__Container__aj17o {
    display: inline-flex;
    gap: var(--ds-xs);
    align-items: center;
    justify-content: center;
    /* stylelint-disable-next-line plugin/no-unsupported-browser-features -- TODO: https://lucidlink.atlassian.net/browse/LUCID-21734 */
    width: max-content;
    max-width: 100%;
    padding: var(--ds-xs) var(--ds-xs) var(--ds-xs) var(--ds-s);
    color: var(--ds-tag-text-color);
    /* stylelint-disable-next-line property-disallowed-list -- needed in component */
    line-height: var(--ds-line-height-big);
    background-color: var(--ds-tag-bg-color);
    border-radius: var(--ds-border-radius-s);
}

.Tag-module__Container__aj17o:focus {
    outline: var(--ds-border-width-focus) solid
        var(--ds-tag-outline-focus-color);
}

.Tag-module__ContainerNegative__r125p {
    color: var(--ds-color-negative);
    background-color: var(--ds-color-negative-bg);
}

.Tag-module__ContainerFocused__yxHk_ {
    outline: var(--ds-border-width-focus) solid
        var(--ds-tag-outline-focus-color);
}

.Tag-module__ContainerDisabled__ui9BZ {
    color: var(--ds-tag-text-disabled-color);
    background-color: var(--ds-tag-bg-disabled-color);
    pointer-events: none;
}

.Tag-module__Button__CjVB2 {
    display: flex;
    align-items: center;
    justify-content: center;
    /* 24px hit area (WCAG 2.5.8) */
    min-width: var(--ds-l);
    min-height: var(--ds-l);
    padding-right: var(--ds-xs);
    color: var(--ds-tag-text-color);
}

.Tag-module__Button__CjVB2:hover {
    cursor: pointer;
}

.Tag-module__ButtonDisabled__UUN1U {
    color: var(--ds-tag-text-disabled-color);
}

.Tag-module__Value__sJZJ9 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Tag-module__Container__aj17o`,
	"ContainerNegative": `Tag-module__ContainerNegative__r125p`,
	"ContainerFocused": `Tag-module__ContainerFocused__yxHk_`,
	"ContainerDisabled": `Tag-module__ContainerDisabled__ui9BZ`,
	"Button": `Tag-module__Button__CjVB2`,
	"ButtonDisabled": `Tag-module__ButtonDisabled__UUN1U`,
	"Value": `Tag-module__Value__sJZJ9`
};
export default ___CSS_LOADER_EXPORT___;
